import React, { FC, useState, useEffect, useRef } from "react";
import { useHistory } from "react-router-dom";
import { Row, Col, Input, Button, InputNumber, Select, Checkbox } from "antd";
import { SwapOutlined, ShareAltOutlined } from "@ant-design/icons";
import { ReactSVG } from "react-svg";
import _ from "lodash";
import { Form } from "antd";
import { useLocation } from "react-router-dom";
import { SocketTopics } from "constants/enums";
import { wrapRequestPayload } from "../../../../helpers/request/RequestPayload";
import {
  getProjectsRequestPublishTopic,
  getProjectsSubscriptionTopic,
  getRespondersSubscriptionTopic,
  getAssetsSubscriptionTopic,
  getPageRequestPublishTopic,
  getPageSubscriptionTopic,
  getCreateRidePagePublishTopic,
  getCreateRidePageSubscriptionTopic,
  getAdminRolesTopic,
  getRideEstimationPublishTopic,
  getRideEstimationSubscriptionTopic,
  getAggregateBdsPublishTopic,
  getAggregateBdsSubscriptionTopic,
  getAccountsRequestPublishTopic,
  getAccountsSubscriptionTopic,
  getUsersSubscriptionTopic,
  callAcceptedPublishTopic,
  getCancelRidePagePublishTopic,
  getCancelRidePageSubscriptionTopic,
  getFocusPageSubscriptionTopic,
  getFixedRatePublishTopic,
  getFixedRateSubscriptionTopic,
  getBlockedAreaPublishTopic,
  getBlockedAreaSubscriptionTopic,
} from "hooks/MQTTConstants";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "reducers/rootReducer";
import {
  SET_SUBMITTED,
  ADD_OTHER_LOCATION,
  ADD_GEOFENCE_LOCATION,
  ADD_STAND_LOCATION,
  DECRYPT_TOKEN,
} from "reducers/reducer";
import { pushNotification } from "utils/notifications";
import { GET_AGGREGATE, INVOKE_WORKFLOW } from "../../../../reducers/reducer";
import { UserTopics } from "constants/enums";
import useSocketActions from "../../../../hooks/socketActions";
import { generateUUID } from "utils/appUtil";
import LocationInput from "../../../../common/LocationInput";
import NumberIncrementInput from "../../../../common/NumberIncrementInput";
import GenderInput from "../../../../common/GenderInput";
import { formatObject, formatForRedis } from "utils/appUtil";
import ScheduleInput from "../../../../common/ScheduleInput";
import RideTypeInput from "../../../../common/RideTypeInput";
import VehicleTypeInput from "../../../../common/VehicleTypeInput";
import VehicleInput from "../../../../common/VehicleInput";
import FareTypeInput from "../../../../common/FareTypeInput";
import NotifyTypeInput from "../../../../common/NotifyTypeInput";
import NumberInput from "../../../../common/NumberInput";
import PayTypeInput from "../../../../common/PayTypeInput";
import moment from "moment";
import ConfirmationModal from "./ConfirmationModal";
import RideFilterModal from "./RideFilterModal";
import ShareDispatchUrlModal from "./ShareDispatchUrlModal";
import "react-phone-number-input/style.css";
import PhoneInput from "react-phone-number-input";
import Geocode from "react-geocode";
Geocode.setApiKey("AIzaSyDNIyoSDV1wnJVW8wdHkiNG-eZ2bMcq0iY");
Geocode.setLanguage("en");
Geocode.setRegion("us");

const { TextArea } = Input;
let typingTimeout;

const DispatchPanel: FC<{
  socket: ISocket;
  params: any;
  fullScreen?: boolean;
  scale?: boolean;
  componentUuids?: string;
}> = ({ socket, params, fullScreen, scale, componentUuids }) => {
  const [nine11Form] = Form.useForm();
  const [error, setError] = useState<string>("");
  const { screens, setScreens } = params;
  const { search } = useLocation();
  const history = useHistory();
  const { projects, accounts } = useSelector((state: RootState) => state.auth);
  const dispatch = useDispatch();
  const {
    selectedResponders,
    submitted,
    page,
    encrypted_token,
    selectedPickup,
    standLocations,
    selectedPage,
  } = useSelector((state: RootState) => state.auth);
  const [searching, setSearching] = useState<boolean>(false);
  const [saving, setSaving] = useState<boolean>(false);
  const [ridePageId, setPageId] = useState<any>(undefined);
  const [ridePageStatus, setPageStatus] = useState<any>(undefined);
  const { getUserRequestPayload } = useSocketActions();
  const adminRoles = useRef(undefined);
  const filterUserRequestId = useRef(generateUUID());
  const [estimation, setEstimation] = useState<any>();
  const [dispatchType, setDispatchType] = useState<any>();
  const [rideType, setRideType] = useState<any>();
  const [vehicleType, setVehicleType] = useState<any>();
  const [isConfirmationModalVisible, setIsConfirmationModalVisible] =
    useState<any>(undefined);
  const [isPhoneFilterModalVisible, setIsPhoneFilterModalVisible] =
    useState<any>(undefined);  
  const [isShareModalVisible, setIsShareModalVisible] =
    useState<boolean>(false);
  const [isCancelModalVisible, setIsCancelModalVisible] =
    useState<boolean>(false);
  const submitPageId = useRef(true);
  const locationType = useRef(undefined);
  const [pay, setPay] = useState<boolean>(false);
  const locationTypeFare = useRef({
    pickup: undefined,
    dropoff: undefined,
  });
  const [blocked, setBlocked] = useState<boolean>(false);

  const getMaskedLocation = (latitude, longitude) => {
    const meter = 417;
    const earth = 6378.137; //radius of the earth in kilometer
    let pi = Math.PI;
    let cos = Math.cos;
    let m = 1 / (((2 * pi) / 360) * earth) / 1000; //1 meter in degree
    const new_latitude = latitude + meter * m;
    m = 1 / (((2 * pi) / 360) * earth) / 1000; //1 meter in degree
    const new_longitude = longitude + (meter * m) / cos(latitude * (pi / 180));
    return {
      lat: new_latitude,
      long: new_longitude,
    };
  };

  const onSubmitHandler = async (values: any) => {
    if (standLocations?.length > 0) return;
    // const query = new URLSearchParams(search);
    const userId = encrypted_token?.userId;
    // const pageId = query.get("pageId");
    const pageId = ridePageId;
    const connectionId = encrypted_token?.connectionId;
    let responders = selectedResponders.map((responder) => {
      return {
        id: responder.id,
        beamId: responder.title,
      };
    });
    if (values["undefined"]) {
      values = values["undefined"];
    }
    values.pickupLocation.type = "incident-location";
    if (values.dropoffLocation) {
      values.dropoffLocation.type = "incident-location";
    }
    const extendedAttributes: any = {};
    Object.keys(values).map((key) => {
      _.merge(extendedAttributes, formatObject(key, key, values[key], [], {}));
    });

    setError(undefined);
    setSearching(true);

    if (extendedAttributes?.payType?.value === "now") {
      console.log("generate payment link and redirect");
      const request = {
        changes: [],
        configId: process.env.REACT_APP_STRIPE_CONFIG_ID,
        request: {
          op: "createPaymentLink",
          priceId: extendedAttributes?.fareType?.stripePriceId,
          redirectUrl: `${window.location.href}&sessionId={CHECKOUT_SESSION_ID}`,
          userId: encrypted_token?.userId,
          cudbServiceId: encrypted_token?.cudbServiceId,
          // quantity: values?.numberOfPeople || 1,
          quantity: 1,
        },
        timeout: 10000,
      };

      console.log("payment request", request);

      dispatch(
        INVOKE_WORKFLOW({
          request,
          callback: (stripeResponse) => {
            console.log("stripe response", stripeResponse);
            if (stripeResponse?.data?.response.url) {
              const formValues = {
                ...values,
                paymentId: stripeResponse?.data?.response?.id,
              };
              delete formValues.payType;
              console.log("form values", formValues);
              localStorage.setItem("formValues", JSON.stringify(formValues));
              const win: Window = window;
              win.location = stripeResponse.data.response.url as string;
            }
          },
        })
      );
      return;
    }

    const sortedAttributes: any = {
      ...extendedAttributes,
      accountName: accounts?.find((x) => {
        return x?.objectId?.toString() === extendedAttributes?.account;
      })?.info?.name,
      fixedFare:
        extendedAttributes?.fareType?.value === "fixed"
          ? extendedAttributes?.fareType?.fare?.toString()
          : undefined,
      fareType: extendedAttributes?.fareType?.value,
      sharePassengerLink: values.sharePassengerLink,
    };
    let vehicleDriver;
    Object.keys(sortedAttributes).map((key) => {
      if (sortedAttributes?.[key]?.type === "vehicle") {
        vehicleDriver = sortedAttributes?.[key]?.value;
      }
    });
    if (vehicleDriver) {
      responders.push({
        id: vehicleDriver,
        beamId: "",
      });
    }
    let eventRequests = [];
    let tripDispatch, roundTripDispatch;
    await Promise.all(
      Object.keys(sortedAttributes).map(async (key) => {
        if (sortedAttributes?.[key]?.type === "dispatchType") {
          const oneWaysortedAttributes = {
            ...sortedAttributes,
          };
          if (sortedAttributes?.[key]?.value === "schedule") {
            oneWaysortedAttributes["scheduleDate"] =
              oneWaysortedAttributes?.[key]?.date;
            oneWaysortedAttributes["scheduleTime"] =
              oneWaysortedAttributes?.[key]?.time;
            const tempDate = new Date(
              oneWaysortedAttributes?.[key]?.dateTimestamp
            );
            const tempTime = new Date(
              oneWaysortedAttributes?.[key]?.timeTimestamp
            );
            tempDate.setHours(tempTime.getHours());
            tempDate.setMinutes(tempTime.getMinutes());
            const leadTime = oneWaysortedAttributes?.leadTime || 0;

            if(tempDate.getTime() - leadTime * 60000 < new Date().getTime()){
              tripDispatch = {
                type: "immediate",
              };
            }
            else{
            tripDispatch = {
              utcDateTime: new Date(
                tempDate.getTime() - leadTime * 60000
              ).toUTCString(),
              rideDateTime: new Date(tempDate.getTime()).toUTCString(),
              ridelocalDateTime: tempDate.getTime(),
              type: "schedule",
            };
          }
          } else {
            tripDispatch = {
              type: "immediate",
            };
          }
          delete oneWaysortedAttributes?.leadTime;
          delete oneWaysortedAttributes?.roundTripLeadTime;
          delete oneWaysortedAttributes?.roundTripNotify;
          if (oneWaysortedAttributes?.notify?.customTime) {
            oneWaysortedAttributes.notify.notifyTime =
              oneWaysortedAttributes.notify.customTime.toString();
          }
          oneWaysortedAttributes.vehicleTypeName =
            oneWaysortedAttributes.vehicleType?.name;
          oneWaysortedAttributes.vehicleType =
            oneWaysortedAttributes.vehicleType?.value;

          const maskedPickupCoordinates = getMaskedLocation(
            oneWaysortedAttributes?.pickupLocation?.coordinates?.lat,
            oneWaysortedAttributes?.pickupLocation?.coordinates?.long
          );
          const maskedAddress = await reverseGeocode(maskedPickupCoordinates);


          eventRequests.push({
            userId,
            rideRequestAttributes: {
              ...oneWaysortedAttributes,
              drivers: responders,
              pickupAddress:
                oneWaysortedAttributes?.pickupLocation?.attributes?.address,
              dropoffAddress:
                oneWaysortedAttributes?.dropoffLocation?.attributes?.address,
              maskedPickupLocation: {
                attributes: {
                  address: maskedAddress,
                },
                coordinates: maskedPickupCoordinates,
              },
              maskedPickupAddress: maskedAddress,

              // maskedPickupLocation: oneWaysortedAttributes?.pickupLocation,
              // maskedPickupAddress: oneWaysortedAttributes?.pickupLocation?.attributes?.address,

              cudbServiceId: projects?.userServiceId,
            },
            drivers: responders,
            connectionId,
            unstructuredAttributes: {
              ...values,
              rideType: {
                type: "rideType",
                value: "oneWay",
              },
              vehicle: undefined,
            },
            pageId: submitPageId.current ? pageId : undefined,
            title: new Date().toLocaleString(),
            dispatch: tripDispatch,
            createdAt: tripDispatch?.ridelocalDateTime || new Date().getTime(),
            cudbServiceId: projects?.userServiceId,
          });
        }
        if (
          sortedAttributes?.[key]?.type === "rideType" &&
          sortedAttributes?.[key]?.value === "roundTrip"
        ) {
          const roundTripAttributes = {
            ...sortedAttributes,
          };
          const roundTripUnstructuredAttributes = {
            ...values,
          };
          roundTripAttributes["scheduleDate"] =
            roundTripAttributes?.[key]?.date;
          roundTripAttributes["scheduleTime"] =
            roundTripAttributes?.[key]?.time;
          const tempDate = new Date(roundTripAttributes?.[key]?.dateTimestamp);
          const tempTime = new Date(roundTripAttributes?.[key]?.timeTimestamp);
          tempDate.setHours(tempTime.getHours());
          tempDate.setMinutes(tempTime.getMinutes());
          const leadTime = roundTripAttributes?.roundTripLeadTime || 0;
          roundTripDispatch = {
            utcDateTime: new Date(
              tempDate.getTime() - leadTime * 60000
            ).toUTCString(),
            rideDateTime: new Date(tempDate.getTime()).toUTCString(),
            ridelocalDateTime: tempDate.getTime(),
            type: "schedule",
          };
          const tempLocation = roundTripAttributes.pickupLocation;
          roundTripAttributes.pickupLocation =
            roundTripAttributes.dropoffLocation;
          roundTripAttributes.dropoffLocation = tempLocation;

          const tempUnstructuredLocation =
            roundTripUnstructuredAttributes.pickupLocation;
          roundTripUnstructuredAttributes.pickupLocation =
            roundTripUnstructuredAttributes.dropoffLocation;
          roundTripUnstructuredAttributes.dropoffLocation =
            tempUnstructuredLocation;

          roundTripUnstructuredAttributes.dispatch = {
            date: roundTripUnstructuredAttributes.rideType.date,
            time: roundTripUnstructuredAttributes.rideType.time,
            type: "dispatchType",
            value: "schedule",
          };

          roundTripUnstructuredAttributes.rideType = {
            type: "rideType",
            value: "oneWay",
          };

          roundTripAttributes.notify = roundTripAttributes?.roundTripNotify;
          delete roundTripAttributes?.leadTime;
          delete roundTripAttributes?.roundTripLeadTime;
          delete roundTripAttributes?.roundTripNotify;
          if (roundTripAttributes?.notify?.customTime) {
            roundTripAttributes.notify.notifyTime =
              roundTripAttributes.notify.customTime.toString();
          }
          roundTripAttributes.vehicleTypeName =
            roundTripAttributes.vehicleType?.name;
          roundTripAttributes.vehicleType =
            roundTripAttributes.vehicleType?.value;
          const roundMaskedPickupCoordinates = getMaskedLocation(
            roundTripAttributes?.pickupLocation?.coordinates?.lat,
            roundTripAttributes?.pickupLocation?.coordinates?.long
          );
          const roundMaskedAddress = await reverseGeocode(
            roundMaskedPickupCoordinates
          );
          eventRequests.push({
            userId,
            rideRequestAttributes: {
              ...roundTripAttributes,
              drivers: responders,
              pickupAddress:
                roundTripAttributes?.pickupLocation?.attributes?.address,
              dropoffAddress:
                roundTripAttributes?.dropoffLocation?.attributes?.address,
              maskedPickupLocation: {
                attributes: {
                  address: roundMaskedAddress,
                },
                coordinates: roundMaskedPickupCoordinates,
              },
              maskedPickupAddress: roundMaskedAddress,
              // maskedPickupLocation: roundTripAttributes?.pickupLocation,
              // maskedPickupAddress: roundTripAttributes?.pickupLocation?.attributes?.address,
              cudbServiceId: projects?.userServiceId,
            },
            drivers: [],
            connectionId,
            unstructuredAttributes: {
              ...roundTripUnstructuredAttributes,
              vehicle: undefined,
            },
            pageId: submitPageId.current ? pageId : undefined,
            title: new Date().toLocaleString(),
            dispatch: roundTripDispatch,
            createdAt:
              roundTripDispatch?.ridelocalDateTime || new Date().getTime(),
            cudbServiceId: projects?.userServiceId,
          });
        }
      })
    );
    eventRequests.map((request) => {
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getCreateRidePagePublishTopic(connectionId),
        wrapRequestPayload(request)
      );
    });
  };

  useEffect(() => {
    if (selectedPage) {
      console.log("selected page", selectedPage);
      setFormValuesFromPage({
        ...selectedPage?.page,
        persistent: {
          static: {
            profile: selectedPage?.page?.profile,
          },
        },
      });
      if(!selectedPage?.ignorePage){
        setPageId(selectedPage?.page?.pageId?.toString());
        setPageStatus(selectedPage?.page?.status || selectedPage?.page?.nonpersistent?.static?.live?.status?.name);
      }
      else{
        setPageId(undefined);
        setPageStatus(undefined);
      }
    }
  }, [selectedPage]);

  const getPassenger = (email, phone) => {
    const customerRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:custom:id`,
          // searchIndex: "beamdev:custom:id",
          searchQuery: `@partitions:{'org\\:${formatForRedis(
            projects?.userServiceId
          )}'}`,
          searchOptions: "VERBATIM TIMEOUT 10000",
        },
        load: {
          info: "$.info",
          email: "$..email",
          phone: "$..phone",
          objectId: "$.objectId",
        },
      },
      filter: {
        expression: `(exists(@email) && @email=='${email}') || (exists(@phone) && @phone=='${phone}')`,
      },
    };
    dispatch(
      GET_AGGREGATE({
        requestData: customerRequest,
        callback: (response) => {
          const customer = response?.[0];
          if (customer) {
            // const pickupLocation = customer?.info?.passenger?.lastPickupLocation
            //   ? {
            //       type: "incident-location",
            //       label:
            //         customer?.info?.passenger?.lastPickupLocation?.attributes
            //           ?.address,
            //       value: {
            //         description:
            //           customer?.info?.passenger?.lastPickupLocation?.attributes
            //             ?.address,
            //         place_id: "",
            //         coordinates:
            //           customer?.info?.passenger?.lastPickupLocation
            //             ?.coordinates,
            //       },
            //     }
            //   : undefined;
            // nine11Form.setFieldsValue({
            //   passengerName: customer?.info?.passenger?.name,
            //   passengerEmail: customer?.info?.passenger?.email,
            //   passengerPhoneNumber: customer?.info?.passenger?.phone,
            //   account: customer?.info?.passenger?.account,
            //   pickupLocation,
            // });

            // if (pickupLocation) {
            //   addOtherLocation({ pickupLocation });
            //   setScreens({
            //     ...screens,
            //     map: true,
            //   });
            //   getFixedFareByLocation(pickupLocation);
            //   getBlockedAreaByLocation(pickupLocation);
            // }

            if (customer?.info?.blockedAt) {
              setBlocked(true);
            } else {
              setBlocked(false);
            }
          }
          else{
            setBlocked(false);
          }
        },
      })
    );
  };

  useEffect(() => {
    if (selectedPickup) {
      console.log("set pickup", selectedPickup);
      const pickupLocation = {
        type: "incident-location",
        label: selectedPickup.location.attributes?.address,
        value: {
          description: selectedPickup?.location.attributes?.address,
          place_id: "",
          coordinates: selectedPickup?.location.coordinates,
        },
      };
      nine11Form.setFieldsValue({
        pickupLocation,
      });

      if (pickupLocation) {
        addOtherLocation({ pickupLocation });
        setScreens({
          ...screens,
          map: true,
        });
        dispatch({ type: ADD_GEOFENCE_LOCATION, payload: undefined });
        dispatch({ type: ADD_STAND_LOCATION, payload: [] });
      }
    }
  }, [selectedPickup]);

  const setFormValuesFromPage = (page) => {
    nine11Form.resetFields();
    dispatch({ type: SET_SUBMITTED, payload: false });
    console.log("page check here", page);
    nine11Form.setFieldsValue({
      ...(page?.persistent?.static?.profile?.unstructuredAttributes ?? {}),
    });
    if (
      page?.persistent?.static?.profile?.unstructuredAttributes?.pickupLocation
    ) {
      addOtherLocation({
        pickupLocation:
          page?.persistent?.static?.profile?.unstructuredAttributes
            ?.pickupLocation,
      });
    }
    if (
      page?.persistent?.static?.profile?.unstructuredAttributes?.dropoffLocation
    ) {
      addOtherLocation({
        dropoffLocation:
          page?.persistent?.static?.profile?.unstructuredAttributes
            ?.dropoffLocation,
      });
    }
    setDispatchType(
      page?.persistent?.static?.profile?.unstructuredAttributes?.dispatch
        ?.value || "immediate"
    );
    setRideType(
      page?.persistent?.static?.profile?.unstructuredAttributes?.rideType
        ?.value || "oneWay"
    );
  };

  useEffect(() => {
    if (page) {
      setFormValuesFromPage(page);
    }
  }, [JSON.stringify(page?.persistent?.static?.profile ?? {})]);

  useEffect(() => {
    if (submitted) {
      setSearching(false);
      // setPageId(undefined);
      if (submitted.status) {
        pushNotification(
          "Ride request submitted",
          "success",
          "TOP_CENTER",
          1000
        );
      } else {
        pushNotification("Ride request failed", "error", "TOP_CENTER", 1000);
      }

      // if (!ridePageId || ridePageId === "") {
      //   localStorage.removeItem("form");
      //   localStorage.removeItem("active");
      //   setTimeout(() => {
      //     nine11Form.resetFields();
      //   }, 500);
      // } else {
      //   nine11Form.setFieldsValue({
      //     vehicle: undefined,
      //   });
      // }
      // localStorage.removeItem("formValues");
      // const query = new URLSearchParams(search);
      // query.delete("sessionId");
      // history.replace({
      //   search: query.toString(),
      // });
      // setEstimation(undefined);
      // setPay(false);
      dispatch({ type: SET_SUBMITTED, payload: false });
      clearForm();
    }
  }, [
    dispatch,
    history,
    nine11Form,
    saving,
    screens,
    search,
    searching,
    setScreens,
    submitted,
  ]);

  const getRideEstimation = (pickupLocation, dropoffLocation) => {
    // const query = new URLSearchParams(search);
    const connectionId = encrypted_token?.connectionId;
    const userId = encrypted_token?.userId;
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getRideEstimationPublishTopic(connectionId),
      wrapRequestPayload({
        pickupLocation: {
          coordinates: pickupLocation?.value?.coordinates,
        },
        dropoffLocation: {
          coordinates: dropoffLocation?.value?.coordinates,
        },
        userId,
        startTime: new Date().getTime(),
        cudbServiceId: projects?.userServiceId,
      })
    );
  };

  const getFixedFareByLocation = (location) => {
    console.log("get fixed rate by location");
    // const query = new URLSearchParams(search);
    const connectionId = encrypted_token?.connectionId;
    const userId = encrypted_token?.userId;
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getFixedRatePublishTopic(connectionId),
      wrapRequestPayload({
        location: {
          coordinates: location?.value?.coordinates,
        },
        dropoffLocation: {
          coordinates: location?.value?.coordinates,
        },
        userId,
        cudbServiceId: projects?.userServiceId,
      })
    );
  };

  const getBlockedAreaByLocation = (location) => {
    // const query = new URLSearchParams(search);
    const connectionId = encrypted_token?.connectionId;
    const userId = encrypted_token?.userId;
    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getBlockedAreaPublishTopic(connectionId),
      wrapRequestPayload({
        location: {
          coordinates: location?.value?.coordinates,
        },
        dropoffLocation: {
          coordinates: location?.value?.coordinates,
        },
        userId,
        cudbServiceId: projects?.userServiceId,
      })
    );
  };

  const getAdminUsers = () => {
    // const query = new URLSearchParams(search);
    const connectionId = encrypted_token?.connectionId;
    const userRequest: any = {
      select: {
        index: {
          searchIndex: `${process.env.REACT_APP_ECO_SYSTEM}:userNameIndex`,
          searchQuery: `@serviceId:{'${formatForRedis(
            projects?.userServiceId
          )}'}`,
          searchOptions: "TIMEOUT 5000",
        },
        load: {
          id: "$.objectId",
          status: "$.nonpersistent.static.live.status",
          live: "$.persistent.static.live",
          firstName: "$..profile.firstName",
        },
      },
      apply: {
        expression: "",
        name: "",
      },
      result: {},
      filter: {
        expression: `exists(@firstName)`,
      },
      anyStatus: false,
    };

    socket.publishToEvent(
      SocketTopics.PublishPageTopics,
      getAggregateBdsPublishTopic(connectionId),
      wrapRequestPayload(userRequest, filterUserRequestId.current)
    );
  };

  useEffect(() => {
    if (projects?.adminUserId) {
      // const query = new URLSearchParams(search);
      const connectionId = encrypted_token?.connectionId;
      const userId = encrypted_token?.userId;
      // getAdminRoles(projects?.adminUserId, projects?.userServiceId);
      getAdminUsers();
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAggregateBdsSubscriptionTopic(connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getUsersSubscriptionTopic(connectionId, projects?.userServiceId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        callAcceptedPublishTopic(userId),
        (response) => {
          console.log("response", response);
          setIsConfirmationModalVisible(response?.data);
        }
      );
    }
  }, [projects]);

  useEffect(() => {
    if (encrypted_token) {
      const query = new URLSearchParams(search);
      const token = query.get("token");
      const sessionId = query.get("sessionId");

      if (token && sessionId) {
        console.log("re submit here");
        const form = JSON.parse(localStorage.getItem("formValues"));
        console.log("form here", form);
        if (form) {
          nine11Form.setFieldsValue({
            ...form,
          });
          onSubmitHandler({ ...form, paymentSessionId: sessionId });
        }
      }

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getProjectsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAccountsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getRespondersSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getAssetsSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCreateRidePageSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCreateRidePageSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getFocusPageSubscriptionTopic(encrypted_token?.userId),
        (response) => {
          setFormValuesFromPage({
            ...response?.page,
            persistent: {
              static: {
                profile: response?.page?.profile,
              },
            },
          });
          setPageId(response?.page?.pageId?.toString());
        }
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getCancelRidePageSubscriptionTopic(encrypted_token?.connectionId),
        (response) => {
          pushNotification(
            "Ride cancelled successfully",
            "success",
            "TOP_CENTER",
            1000
          );
          dispatch({ type: SET_SUBMITTED, payload: false });
          clearForm();
        }
      );
      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getPageSubscriptionTopic(encrypted_token?.connectionId)
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getProjectsRequestPublishTopic(encrypted_token?.connectionId),
        wrapRequestPayload({
          userId: encrypted_token?.userId,
        })
      );
      socket.publishToEvent(
        SocketTopics.PublishPageTopics,
        getAccountsRequestPublishTopic(encrypted_token?.connectionId),
        wrapRequestPayload({
          userId: encrypted_token?.userId,
        })
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getFixedRateSubscriptionTopic(encrypted_token?.connectionId),
        ({ response }) => {
          console.log("fixed rate response", response);

          const priceList = response?.data?.fixedRate?.priceConfig;
          const numberOfPassengers = nine11Form.getFieldValue("numberOfPeople");

          let selectedPrice = priceList?.find((x) => {
            return x?.numberOfPassengers === numberOfPassengers;
          });
          if (!selectedPrice) {
            priceList?.sort(
              (a, b) => parseFloat(b.price) - parseFloat(a.price)
            );
            selectedPrice = priceList?.[0];
          }

          console.log("selected price", selectedPrice);

          if (
            selectedPrice?.price &&
            response?.data?.fixedRate?.[locationType.current]
          ) {
            setPay(true);
            nine11Form.setFieldsValue({
              fareType: {
                type: "fareType",
                value: "fixed",
                fare: selectedPrice?.price,
                ...selectedPrice,
              },
              payType: {
                type: "payType",
                value: "meter",
              },
            });
          }
          locationTypeFare.current[locationType.current] = priceList;
          if (
            !locationTypeFare.current.pickup &&
            !locationTypeFare.current.dropoff
          ) {
            nine11Form.setFieldsValue({
              fareType: {
                type: "fareType",
                value: "variable",
              },
              payType: undefined,
            });
            setPay(false);
          }
        }
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getBlockedAreaSubscriptionTopic(encrypted_token?.connectionId),
        ({ response }) => {
          console.log("blocked area response", response);
          if (response?.data?.blockedArea) {
            dispatch({
              type: ADD_GEOFENCE_LOCATION,
              payload: response?.data?.blockedArea?.geofence,
            });
            dispatch({
              type: ADD_STAND_LOCATION,
              payload: response?.data?.blockedArea?.pois,
            });
          } else {
            dispatch({ type: ADD_GEOFENCE_LOCATION, payload: undefined });
            dispatch({ type: ADD_STAND_LOCATION, payload: [] });
          }
        }
      );

      socket.subscribeToEvent(
        SocketTopics.SubscribePageTopics,
        getRideEstimationSubscriptionTopic(encrypted_token?.connectionId),
        (response) => {
          const estimation = response?.response;
          console.log("estimation", estimation?.data);
          if (estimation?.data?.leadTime > -1) {
            nine11Form.setFieldsValue({
              leadTime: Math.ceil(estimation?.data.leadTime),
            });
          }
          if (estimation?.data?.roundTripLeadTime > -1) {
            nine11Form.setFieldsValue({
              roundTripLeadTime: Math.ceil(estimation?.data.roundTripLeadTime),
            });
          }
          if (estimation?.data.estimate) {
            const estimate = [];
            estimate.push({
              label: "Estimate",
              value: `${estimation?.data.estimate} ${estimation?.data.currency}`,
            });
            estimate.push({
              label: "Distance",
              value: `${((estimation?.data.distance / 1000) * 0.6214).toFixed(2)} miles`,
            });
            estimate.push({
              label: "Duration",
              value: `${(estimation?.data.duration / 60).toFixed(2)} mins`,
            });
            estimate.push({
              label: "Wait time",
              value: `${(estimation?.data.waitTime / 60).toFixed(2)} mins`,
            });
            setEstimation(estimate);
          }
        }
      );
      if (encrypted_token?.pageId) {
        socket.publishToEvent(
          SocketTopics.PublishPageTopics,
          getPageRequestPublishTopic(encrypted_token?.connectionId),
          wrapRequestPayload(
            {
              objectId: encrypted_token?.pageId,
              paths: ["$"],
              returnPaths: ["$"],
            },
            encrypted_token?.pageId
          )
        );
      }
    }
  }, [encrypted_token]);

  useEffect(() => {
    if (socket.client) {
      console.log("subscribe here");
      const query = new URLSearchParams(search);
      const userId = query.get("userId");
      const connectionId = query.get("connectionId");
      const pageId = query.get("pageId");
      const token = query.get("token");
      setPageId(pageId);
      if (token) {
        console.log("decry");
        dispatch(
          DECRYPT_TOKEN({
            data: { payload: token },
            callback: (data) => {},
          })
        );
      } else {
        dispatch({
          type: "ADD_ENCRYPTED_TOKEN",
          payload: {
            connectionId,
            userId,
            pageId,
          },
        });
      }
    }
  }, [search, socket.client]);

  const addOtherLocation = (location) => {
    dispatch({ type: ADD_OTHER_LOCATION, payload: location });
  };

  const clearForm = () => {
    setTimeout(() => {
      const query = new URLSearchParams(search);
      query.delete("pageId");
      query.delete("sessionId");
      history.replace({
        search: query.toString(),
      });
      localStorage.removeItem("form");
      localStorage.removeItem("formValues");
      localStorage.removeItem("active");
      dispatch({ type: SET_SUBMITTED, payload: false });
      dispatch({
        type: "SET_SELECTED_PAGE",
        payload: { page: undefined },
      });
      nine11Form.resetFields();
      nine11Form.setFieldsValue({
        dispatch: {
          type: "dispatchType",
          value: "immediate",
        },
        rideType: {
          type: "rideType",
          value: "oneWay",
        },
        fareType: {
          type: "fareType",
          value: "variable",
        },
      });
      setEstimation(undefined);
      setPageId(undefined);
      setPay(false);
      setBlocked(false);
    });
  };

  const reverseGeocode = async (marker: any) => {
    try {
      const response = await Geocode.fromLatLng(marker.lat, marker.long);
      return response.results[0].formatted_address;
    } catch (e) {
      return "Unknown";
    }
  };

  return (
    <div
      className="main-column ride-dispatch-panel mr-4"
      style={scale ? { height: "auto" } : {}}
    >
      <div className="main-content">
        <Form
          className="auth-form"
          name="register-form"
          initialValues={{
            dispatch: {
              type: "dispatchType",
              value: "immediate",
            },
            rideType: {
              type: "rideType",
              value: "oneWay",
            },
            fareType: {
              type: "fareType",
              value: "variable",
            },
          }}
          id="register-form"
          layout="vertical"
          form={nine11Form}
          onFinish={onSubmitHandler}
          requiredMark={false}
          onValuesChange={(value, allValues) => {
            localStorage.setItem("form", JSON.stringify(allValues));
          }}
          style={!fullScreen ? { height: "48vh" } : {}}
        >
          <div className="main-header">
            <div className="d-flex">
              <h3 className="ml-3">
                {ridePageId && page
                  ? `${page?.persistent?.static?.metatdata?.title}`
                  : "Ride booking"}
              </h3>
            </div>
            <div className="d-flex">
              {encrypted_token && !encrypted_token?.cudbServiceId && (
                <ShareAltOutlined
                  style={{
                    color: "#869cbd",
                    fontSize: 21,
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    setIsShareModalVisible(true);
                  }}
                />
              )}

              {/* <ReactSVG
                src="/images/expand-icon.svg"
                className="close-icon mr-4"
                onClick={() => {
                  setScreens({
                    ...screens,
                    map: true,
                  });
                }}
              /> */}
            </div>
          </div>

          <div
            className="main-cards"
            // style={{ maxHeight: "calc(100vh)" }}
            style={{ maxHeight: scale ? "calc(100vh)" : "calc(100vh - 200px)" }}
          >
            <Row>
              <Col span={24}>
                <Form.Item name="passengerName">
                  <Input placeholder="Passenger name" autoComplete="on" />
                </Form.Item>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col span={21} className="">
                <Form.Item
                  name="passengerPhoneNumber"
                  rules={[{ required: true, message: "**Required Field" }]}
                >
                  <PhoneInput
                    placeholder="Phone number"
                    defaultCountry="US"
                    // value={value}
                    onChange={(phone) => {
                      console.log("phone", phone);
                      // const phone = e.target.value;

                      if (typingTimeout) clearTimeout(typingTimeout);
                      typingTimeout = setTimeout(() => {
                        getPassenger(undefined, phone);
                      }, 500);
                    }}
                  />
                </Form.Item>

                {blocked && (
                  <Form.Item>
                    <p className="error">**Blocked customer</p>
                  </Form.Item>
                )}
              </Col>

              <Col span={3}>
                <Button
                  className="beam-btn icon-btn ml-2"
                  onClick={() => {
                    const phone = nine11Form.getFieldValue(
                      "passengerPhoneNumber"
                    );

                    // dispatch({
                    //   type: "SEARCH_PAGES_BY_PHONE",
                    //   payload: { phone },
                    // });

                    setIsPhoneFilterModalVisible({phone});

                    // getPassenger(undefined, phone);
                  }}
                >
                  Search
                </Button>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col span={24}>
                <Form.Item name="passengerEmail">
                  <Input
                    placeholder="Email"
                    autoComplete="email"
                    onChange={(e) => {
                      const email = e.target.value;
                      if (typingTimeout) clearTimeout(typingTimeout);
                      typingTimeout = setTimeout(() => {
                        getPassenger(email, undefined);
                      }, 500);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <hr />
            {/* <Row className="mt-3">
              <Col span={12} className="pr-2">
                <Form.Item name="accountNumber">
                  <Input placeholder="Account Number" autoComplete="on" />
                </Form.Item>
              </Col>
              <Col span={12} className="pl-2">
                <Form.Item name="accountName">
                  <Input placeholder="Account Name" autoComplete="on" />
                </Form.Item>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col span={24}>
                <Form.Item name="bookerName">
                  <Input placeholder="Booker name" autoComplete="on" />
                </Form.Item>
              </Col>
            </Row> */}

            <Row className="mt-3">
              <Col span={24}>
                <Form.Item
                  name="account"
                  // rules={[{ required: true, message: "**Required Field" }]}
                >
                  <Select
                    showSearch
                    className="w-full"
                    placeholder="Account name"
                    onChange={(value) => {
                      // onProjectChange(value);
                    }}
                    filterOption={(input, option) =>
                      (option!.children as unknown as string)
                        .toLowerCase()
                        .includes(input.toLowerCase())
                    }
                  >
                    {accounts?.map((account, index) => (
                      <Select.Option value={account.objectId?.toString()}>
                        {account.info.name}
                      </Select.Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <hr />
            <Row className="mt-3">
              <Col span={21}>
                <Form.Item
                  name="pickupLocation"
                  rules={[{ required: true, message: "**Required Field" }]}
                >
                  <LocationInput
                    placeholder="Pick up location"
                    onChange={(location) => {
                      addOtherLocation({ pickupLocation: location });
                      setScreens({
                        ...screens,
                        map: true,
                      });
                      const dropoffLocation =
                        nine11Form.getFieldValue("dropoffLocation");
                      if (dropoffLocation?.value?.coordinates) {
                        getRideEstimation(location, dropoffLocation);
                      }
                      locationType.current = "pickup";
                      getFixedFareByLocation(location);
                      getBlockedAreaByLocation(location);
                    }}
                  />
                </Form.Item>
                {standLocations?.length > 0 && (
                  <Form.Item>
                    <p className="error">
                      **Blocked Area. Please select nearest pickup point on the
                      map
                    </p>
                  </Form.Item>
                )}
              </Col>

              <Col span={3}>
                <Button
                  className="beam-btn icon-btn ml-2"
                  // style={{
                  //   transform: "rotate(90deg)",
                  //   float: "right",
                  // }}
                  onClick={() => {
                    let pickupLocation =
                      nine11Form.getFieldValue("pickupLocation");
                    let dropoffLocation =
                      nine11Form.getFieldValue("dropoffLocation");
                    if (
                      pickupLocation === undefined ||
                      dropoffLocation === undefined
                    )
                      return;
                    nine11Form.setFieldsValue({
                      pickupLocation: dropoffLocation,
                      dropoffLocation: pickupLocation,
                    });
                    addOtherLocation({
                      pickupLocation: dropoffLocation,
                    });
                    addOtherLocation({
                      dropoffLocation: pickupLocation,
                    });

                    getRideEstimation(dropoffLocation, pickupLocation);
                  }}
                >
                  {/* <SwapOutlined /> */}
                  Swap
                </Button>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col span={24}>
                <Form.Item
                  name="dropoffLocation"
                  // rules={[{ required: true, message: "**Required Field" }]}
                >
                  <LocationInput
                    placeholder="Drop off location"
                    onChange={(location) => {
                      addOtherLocation({ dropoffLocation: location });
                      const pickupLocation =
                        nine11Form.getFieldValue("pickupLocation");
                      if (pickupLocation?.value?.coordinates) {
                        getRideEstimation(pickupLocation, location);
                      }
                      locationType.current = "dropoff";
                      getFixedFareByLocation(location);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {estimation && (
              <Row className="beam-modal summary-modal analytics-summary-modal d-flex mt-3">
                <Col span={24}>
                  <h4>Estimation</h4>
                </Col>

                <Col span={24}>
                  <ul className="incident-information mt-2">
                    {estimation.map((item, i) => (
                      <li key={i}>
                        <Row>
                          <Col span={12}>
                            <p>{item.label}</p>
                          </Col>
                          <Col span={12}>
                            <p>{item.value}</p>
                          </Col>
                        </Row>
                      </li>
                    ))}
                  </ul>
                </Col>
              </Row>
            )}

            <hr />

            <Row className="mt-3">
              <Col span={24}>
                <Form.Item
                  name="dispatch"
                  rules={[
                    { required: true, message: "**Required Field" },
                    {
                      message: "**Required Field",
                      validator: async (_, value) => {
                        if (
                          value?.value === "schedule" &&
                          (!value?.date || !value?.time)
                        ) {
                          return Promise.reject("**Required Field");
                        }
                        // Promise.resolve()
                      },
                    },
                  ]}
                >
                  <ScheduleInput
                    placeholder="Select dispatch type"
                    dispatchOptions={[
                      { id: "immediate", name: "Immediate" },
                      { id: "schedule", name: "Schedule" },
                    ]}
                    onChange={(value) => {
                      setDispatchType(value.value);

                      // nine11Form.setFieldsValue({
                      //   leadTime: 0,
                      // });
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {dispatchType === "schedule" && (
              <React.Fragment>
                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item
                      name="leadTime"
                      rules={[{ required: true, message: "**Required Field" }]}
                    >
                      <NumberInput
                        placeholder={"Enter lead time"}
                        onChange={(value) => {}}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                {/* <Row>
                  <Col span={24}>
                    <Form.Item
                      name="notify"
                      // rules={[{ required: true, message: "**Required Field" }]}
                      rules={[
                        {
                          message: "**Required Field",
                          validator: async (_, value) => {
                            if (value && !value.notifyTime) {
                              return Promise.reject("**Required Field");
                            }
                            // Promise.resolve()
                          },
                        },
                      ]}
                    >
                      <NotifyTypeInput onChange={(value) => {}} />
                    </Form.Item>
                  </Col>
                </Row> */}
              </React.Fragment>
            )}

            <hr />

            <Row className="mt-3">
              <Col span={24}>
                <Form.Item
                  name="rideType"
                  // rules={[{ required: true, message: "**Required Field" }]}
                  rules={[
                    { required: true, message: "**Required Field" },
                    {
                      message: "**Required Field",
                      validator: async (_, value) => {
                        if (value?.value === 'roundTrip' && (!value?.date || !value?.time)){
                          return Promise.reject("**Required Field");
                        }
                        // Promise.resolve()
                      },
                    },
                  ]}
                >
                  <RideTypeInput
                    placeholder="Select ride type"
                    onChange={(value) => {
                      setRideType(value.value);
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>

            {rideType === "roundTrip" && (
              <React.Fragment>
                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item
                      name="roundTripLeadTime"
                      rules={[{ required: true, message: "**Required Field" }]}
                    >
                      <NumberInput
                        placeholder={"Enter lead time"}
                        onChange={(value) => {}}
                      />
                    </Form.Item>
                  </Col>
                </Row>

                <Row>
                  <Col span={24}>
                    <Form.Item
                      name="roundTripNotify"
                      // rules={[{ required: true, message: "**Required Field" }]}
                    >
                      {/* <NotifyTypeInput onChange={(value) => {}} /> */}
                    </Form.Item>
                  </Col>
                </Row>
              </React.Fragment>
            )}

            <hr />

            <Row className="mt-3">
              <Col span={24}>
                <Form.Item
                  name="fareType"
                  rules={[{ required: true, message: "**Required Field" }]}
                >
                  <FareTypeInput
                    placeholder="Select fare type"
                    onChange={(value) => {}}
                    disabled={encrypted_token?.cudbServiceId}
                  />
                </Form.Item>
              </Col>
            </Row>

            <hr />

            {pay && (
              <React.Fragment>
                <Row className="mt-3">
                  <Col span={24}>
                    <Form.Item
                      name="payType"
                      rules={[{ required: true, message: "**Required Field" }]}
                    >
                      <PayTypeInput
                        placeholder="Select pay type"
                        onChange={(value) => {}}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <hr />
              </React.Fragment>
            )}

            <Row className="mt-3">
              <Col span={24}>
                <Form.Item
                  name="vehicleType"
                  // rules={[{ required: true, message: "**Required Field" }]}
                >
                  <VehicleTypeInput
                    placeholder="Select vehicle type"
                    onChange={(value) => {
                      setVehicleType(value?.value);
                    }}
                    socket={socket}
                  />
                </Form.Item>
              </Col>
            </Row>

            <hr />

            <Row className="mt-3">
              <Col span={24}>
                <Form.Item
                  name="vehicle"
                  // rules={[{ required: true, message: "**Required Field" }]}
                >
                  <VehicleInput
                    placeholder="Select vehicle"
                    onChange={(value) => {}}
                    socket={socket}
                    vehicleType={vehicleType}
                  />
                </Form.Item>
              </Col>
            </Row>

            <hr />

            <div className="d-flex mt-3">
              <div className="sub-cards-block mr-1">
                <h5>Number of people</h5>
                <Form.Item name="numberOfPeople">
                  <NumberIncrementInput
                    onChange={(value) => {
                      console.log("number of people", value);

                      console.log("test", locationTypeFare.current);

                      let selectedPickupPrice =
                        locationTypeFare.current?.pickup?.find((x) => {
                          return x?.numberOfPassengers === value;
                        });
                      if (!selectedPickupPrice) {
                        locationTypeFare.current?.pickup?.sort(
                          (a, b) => parseFloat(b.price) - parseFloat(a.price)
                        );
                        selectedPickupPrice =
                          locationTypeFare.current?.pickup?.[0];
                      }

                      let selectedDropoffPrice =
                        locationTypeFare.current?.dropoff?.find((x) => {
                          return x?.numberOfPassengers === value;
                        });
                      if (!selectedDropoffPrice) {
                        locationTypeFare.current?.dropoff?.sort(
                          (a, b) => parseFloat(b.price) - parseFloat(a.price)
                        );
                        selectedDropoffPrice =
                          locationTypeFare.current?.dropoff?.[0];
                      }

                      let fare = { price: -1 };
                      if (selectedPickupPrice?.price > fare?.price)
                        fare = selectedPickupPrice;
                      if (selectedDropoffPrice?.price > fare?.price)
                        fare = selectedDropoffPrice;

                      if (fare?.price > 0) {
                        nine11Form.setFieldsValue({
                          fareType: {
                            type: "fareType",
                            value: "fixed",
                            fare: fare?.price,
                            ...fare,
                          },
                        });
                      }
                    }}
                  />
                </Form.Item>
                <hr />
                <h5>Number of luggage</h5>
                <Form.Item name="numberOfLuggage">
                  <NumberIncrementInput onChange={() => {}} />
                </Form.Item>
              </div>
              <div className="sub-cards-block mx-1">
                <h5>Driver Gender</h5>
                <Form.Item name="driverGender">
                  <GenderInput onChange={() => {}} />
                </Form.Item>
              </div>
            </div>
            <Row className="mt-3">
              <Col span={24}>
                <Form.Item name="instructions">
                  <TextArea
                    autoSize={{ minRows: 4, maxRows: 6 }}
                    placeholder="Instructions"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row className="d-flex px-2">
              <Col>
                <p>Optional</p>
              </Col>
              <Col>
                <p>max. 500 character</p>
              </Col>
            </Row>

            {selectedResponders && selectedResponders.length > 0 && (
              <Row className="mt-3">
                <Col span={24}>
                  <h4>Drivers</h4>
                  {selectedResponders &&
                    selectedResponders.map((responder, index) => (
                      <Row className="responder-item mt-3">
                        <Col span={4}>
                          <img
                            src={`/images/users/user.png`}
                            alt=""
                            width="50"
                            height="50"
                          />
                        </Col>
                        <Col span={8}>
                          <h5>{`${responder?.profile?.firstName} ${responder?.profile?.lastName}`}</h5>
                          <p>ID: {responder?.beamIds?.[0]}</p>
                        </Col>
                        <Col span={6}>
                          <Button className="beam-btn action-btn">
                            Driver
                          </Button>
                        </Col>
                        <Col span={6} className="t-right">
                          <Button className="beam-btn mr-2">
                            <img
                              src={`/images/flag-green.png`}
                              alt=""
                              width="15"
                              height="15"
                            />
                          </Button>
                        </Col>
                      </Row>
                    ))}
                </Col>
              </Row>
            )}

            <Row className="mt-3">
              <Col span={24}>
                <Form.Item name="sharePassengerLink" valuePropName="checked">
                  <Checkbox>Do you want to share link with passenger?</Checkbox>
                </Form.Item>
              </Col>
            </Row>
          </div>

          {error && (
            <Form.Item>
              <p className="error">{error}</p>
            </Form.Item>
          )}
          <Row className="action-grp mt-3">
            <Col span={ridePageId ? 6 : 12} className="px-2">
              <Button
                className="beam-btn yellow-btn bordered w-full w-full"
                onClick={() => {
                  clearForm();
                }}
              >
                Clear
              </Button>
            </Col>

            {ridePageId && (
              <Col span={6} className="px-2">
                <Button
                  className="beam-btn orange-btn bordered w-full w-full"
                  onClick={() => {
                    setIsCancelModalVisible(true);
                  }}
                  disabled={ridePageStatus === "black"}
                >
                  Cancel
                </Button>
              </Col>
            )}

            <Col span={ridePageId ? 6 : 12} className="pl-2">
              <Button
                className="beam-btn green-btn cover w-full"
                htmlType="submit"
                loading={searching}
                disabled={blocked || ridePageStatus === "green"}
                onClick={() => {
                  submitPageId.current = true;
                }}
              >
                {/* {ridePageId ? "Save" : "Dispatch"} */}
                Dispatch
              </Button>
            </Col>

            {ridePageId && (
              <Col span={6} className="pl-3">
                <Button
                  className="beam-btn yellow-btn bordered w-full"
                  htmlType="submit"
                  loading={searching}
                  disabled={blocked}
                  onClick={() => {
                    submitPageId.current = false;
                  }}
                >
                  New
                </Button>
              </Col>
            )}
          </Row>
        </Form>
      </div>

      {isCancelModalVisible && (
        <ConfirmationModal
          onClose={() => {
            setIsCancelModalVisible(undefined);
          }}
          handleConfirm={() => {
            // const query = new URLSearchParams(search);
            // const userId = query.get("userId");
            // const pageId = query.get("pageId");
            // const connectionId = query.get("connectionId");

            socket.publishToEvent(
              SocketTopics.PublishPageTopics,
              getCancelRidePagePublishTopic(encrypted_token?.connectionId),
              wrapRequestPayload({
                pageId: ridePageId,
                userId: encrypted_token?.userId,
                cudbServiceId: projects?.userServiceId,
              })
            );
            setIsCancelModalVisible(undefined);
          }}
          message={`Are you sure you want to cancel ride?`}
        />
      )}

{isPhoneFilterModalVisible?.phone &&
      <RideFilterModal socket={socket} phone={isPhoneFilterModalVisible?.phone} onClose={() => {
            setIsPhoneFilterModalVisible(undefined);
          }}/>
        }

      {isShareModalVisible && (
        <ShareDispatchUrlModal
          onClose={() => {
            setIsShareModalVisible(false);
          }}
          socket={socket}
        />
      )}

      {isConfirmationModalVisible?.reservation && (
        <ConfirmationModal
          onClose={() => {
            setIsConfirmationModalVisible(undefined);
          }}
          handleConfirm={() => {
            getPassenger(
              undefined,
              isConfirmationModalVisible?.reservation?.phoneNumber
            );
            setIsConfirmationModalVisible(undefined);
          }}
          message={`Incoming call: ${isConfirmationModalVisible?.reservation?.phoneNumber}`}
        />
      )}
    </div>
  );
};

export default DispatchPanel;

// <Input
//   placeholder="Phone Number"
//   autoComplete="on"
//   onChange={(e) => {
//   const phone = e.target.value;
//   if (typingTimeout) clearTimeout(typingTimeout);
//   typingTimeout = setTimeout(() => {
//     getPassenger(undefined, phone);
//   }, 500);
// }}
// />
